import { ChartLine } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChartLineIcon = createLucideIcon(ChartLine);
